import TextField from "@mui/material/TextField";
import AddItemDialog from "../../Dialogs/AddItemDialog";
import { useEffect, useState } from "react";
import { ExamOverviewRow } from "../../../interfaces/examInterfaces";
import { createErrorText } from "../Functions";

const AddFolderDialog = ({
  open,
  handleCancel,
  saveFolder,
  paths,
  pathString,
}: {
  open: boolean;
  handleCancel: () => void;
  saveFolder: (name: string) => void;
  paths: Record<string, ExamOverviewRow[]> | null;
  pathString: string;
}) => {
  const [name, setName] = useState("");
  const [touchedName, setTouchedName] = useState(false);
  const [dialogInitialized, setDialogInitialized] = useState(false);
  const [errorText, setErrorText] = useState<string | null>(null);

  const resetFields = () => {
    setName("");
    setTouchedName(false);
    setDialogInitialized(false);
  };

  useEffect(() => {
    if (open) {
      setDialogInitialized(true);
    } else {
      resetFields();
    }
  }, [open]);

  useEffect(() => {
    setErrorText(createErrorText(paths, pathString, name));
  }, [name]);

  return (
    <AddItemDialog
      open={open}
      handleCancel={() => handleCancel()}
      handleConfirm={() => saveFolder(name)}
      title={"Neuer Ordner"}
      description={"Bitte benenne den Ordner"}
      confirmText={"OK"}
      confirmAllowed={errorText === null}
    >
      <TextField
        margin="dense"
        id="name"
        label="Name"
        required
        error={errorText !== null && touchedName}
        style={{ width: 330 }}
        autoFocus
        value={name}
        onBlur={() => {
          if (dialogInitialized) {
            setTouchedName(true);
          }
        }}
        onChange={(e) => {
          setName(e.target.value);
          setTouchedName(true);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter" && errorText === null) {
            saveFolder(name);
          }
        }}
        helperText={errorText ?? errorText}
      />
    </AddItemDialog>
  );
};

export default AddFolderDialog;
